module.exports = __webpack_public_path__ + "img/QR-Icon.3f998d53.svg";